export default __webpack_public_path__ + "static/media/37_BottomRightSquares_Alpha.59c33e2f.mp4";